import "./PetitPopHome.module.css";
import TestataFelinova from "@/reusable_sections/Header";
import PrecisionEngineeringHub from "./sections/PrecisionEngineeringHub";
import WarumFunktioniertDas from "./sections/WarumFunktioniertDas";
import The2026TechShop from "./sections/The2026TechShop";
import SeasonalArrivals from "./sections/SeasonalArrivals";
import TheSashaLandonExperience from "./sections/TheSashaLandonExperience";
import DirectLeverbaarMaterieel from "./sections/DirectLeverbaarMaterieel";
import VibrantMoments from "./sections/VibrantMoments";
import Footer from "@/reusable_sections/Footer";
export default function PetitPopHomePage() {
  return <div>
      <TestataFelinova />
      <PrecisionEngineeringHub />
      <WarumFunktioniertDas />
      <The2026TechShop />
      <SeasonalArrivals />
      <TheSashaLandonExperience />
      <DirectLeverbaarMaterieel />
      <VibrantMoments />
      <Footer />
    </div>;
}